import i18next from "i18next";
import getPercentileColor from "../../util/getPercentileColor";
import SRS from "../../../../services/StudentRecordService";

/**
 * Generates subscores using reading rope report as a data source.
 * @param {string} studentId
 * @param {string} locale
 */
export async function generateSubscores(studentId, locale="EN_US") {
  const {readingRopeReport} = await SRS.getReadingRopeData({studentId, locale});
  return generateSubscoresFromReadingRope(readingRopeReport, locale);
}

export function generateSubscoresFromReadingRope(readingRope, locale) {
  if(!readingRope) return null;
  if(!readingRope.threads) return null;
  if(!readingRope.threads.length) return null;

  const domains = [].concat(...readingRope.threads.map(({domains}) => domains || []));

  return {
    decoding: transformDomainToSubScore(domains.find(d => d.label === 'Decoding'), locale),
    phonologicalAwareness: transformDomainToSubScore(domains.find(d => d.label === 'Phonological Awareness'), locale),
    highFrequencyWords: transformDomainToSubScore(domains.find(d => d.label === 'Sight Recognition'), locale),
    backgroundKnowledge: transformDomainToSubScore(domains.find(d => d.label === 'Background Knowledge'), locale),
    structuresAndReasoning: transformDomainToSubScore(domains.find(d => d.label === 'Structure & Reasoning'), locale),
    vocabulary: transformDomainToSubScore(domains.find(d => d.label === 'Vocabulary'), locale),
  }
}

function transformDomainToSubScore(domain) {
  const {mastery} = domain;
  const t = i18next.getFixedT(null, 'teacher_parent_report');
  return {
    percentile: mastery.value,
    color: getPercentileColor(mastery.pacing),
    statusText: t(mastery.pacing),
    description: t(`domain_descriptions.${domain.label}`),
    label: domain.label,
    pacing: mastery.pacing,
  }
}